import React from 'react'
import { useTranslation } from 'react-i18next'
import { Tag as TagAnt } from 'antd'
import {
  ApprovedBy,
  RequestUserDataStatus,
  RequestApprovalStatus,
  RequestConferenceStatus,
  RequestClosingStatus,
  RequestTicketStatus,
  CheckedBy,
  ControlledBy
} from 'src/types'

type status =
  | 'APPROVING'
  | 'EMISSION_REPROVED'
  | 'ISSUING'
  | 'QUOTATION_REPROVED'
  | 'QUOTATION'
  | 'QUOTING'
  | 'REQUESTER'
  | 'RESERVED'
  | 'TRAVELER'
  | 'WAITING_RESERVATION'
  | ApprovedBy
  | CheckedBy
  | ControlledBy
  | RequestApprovalStatus
  | RequestClosingStatus
  | RequestConferenceStatus
  | RequestTicketStatus
  | RequestUserDataStatus
function getStatusColor(status: status) {
  switch (status) {
    case 'APPROVAL_PENDING':
    case 'APPROVED':
    case 'APPROVER':
    case 'APPROVING':
    case 'EMISSION_PENDING':
    case 'ISSUED':
    case 'RESERVED':
    case 'TRAVELER':
      return 'blue'
    case 'AUTO':
    case 'CLOSING_PENDING':
    case 'CONFERENCE_PENDING':
    case 'ISSUING':
    case 'CHECKER':
    case 'CLOSER':
      return 'geekblue'
    case 'APPROVAL_REPROVED':
    case 'CANCELED':
    case 'CLOSING_REPROVED':
    case 'CONFERENCE_REPROVED':
    case 'EMISSION_REPROVED':
    case 'EXPIRED':
    case 'QUOTATION_REPROVED':
    case 'REPROVED':
      return 'red'
    case 'FINISHED':
      return 'purple'
    case 'PENDING':
    case 'QUOTATION_PENDING':
    case 'QUOTATION':
    case 'QUOTING':
    case 'WAITING_RESERVATION':
      return 'orange'
    case 'UNDERWAY':
      return 'green'
  }
}

function UnifiedTag({ status }: { status: status }) {
  const { t } = useTranslation()
  return (
    <TagAnt color={getStatusColor(status)}>
      {t(`common.status.unified.${status}`.toLowerCase())}
    </TagAnt>
  )
}

export default UnifiedTag
